import classNames from 'classnames';
import { FieldProps, useFormikContext } from 'formik';
import { useCallback } from 'react';
import UDFormFieldWrapper from 'ud-form/wrapper';
import HighlightWrapper from '../highlight-wrapper';
import { UDFormComponentProps } from '../types';
import UDDateInput, { UDDateInputProps } from './component';

export type UDFormDateInputProps = UDFormComponentProps &
  Omit<UDDateInputProps, 'hasError' | 'valid' | 'onChange'> & { highlight?: boolean };

const UDFormDateInput = (props: UDFormDateInputProps) => {
  const { name, label, labelProps, containerProps, required, highlight, tooltip, tooltipProps, ...otherProps } = props;
  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (date: Date | null) => {
      setFieldValue(name, date ? date.toISOString() : date);
    },
    [name],
  );
  return (
    <UDFormFieldWrapper
      name={name}
      containerProps={containerProps}
      label={label}
      labelProps={labelProps}
      required={required}
      tooltip={tooltip}
      tooltipProps={tooltipProps}
    >
      {({ field, meta }: FieldProps<any>) => {
        return (
          <HighlightWrapper highlight={highlight} className="w-full">
            <UDDateInput
              {...field}
              className={classNames('w-full', otherProps?.className)}
              onChange={onChange}
              hasError={!!meta.error}
              valid={!meta.error && meta.touched && meta.value}
              {...otherProps}
            />
          </HighlightWrapper>
        );
      }}
    </UDFormFieldWrapper>
  );
};

export default UDFormDateInput;
